import React from "react";
import { ElfsightWidget } from 'react-elfsight-widget';
import Delimiter from "../general/delimiter";

import "../../styles/review-box.scss"

const ReviewBox = () => {
    return (
        <div id="ReviewBox">
            {/* <Delimiter text={"Vad säger våra kunder?"} subText={""} /> */}
            <ElfsightWidget widgetId={"f3f3d299-2281-4ad1-8b02-414657cb8119"} lazy="in-viewport" modern />
        </div>
    );
};

export default ReviewBox;
